<template>
    <div>
        <h3 class="title_header">用户管理</h3>

        <div class="from_header">
            <div class="seache_left">
                <div class="seache_item">
                    <div class="label">姓名：</div>
                    <div class="search_input">
                        <el-input  v-model="searchForm.realName" clearable placeholder="请输入姓名"/>
                    </div>
                </div>
                <div class="seache_item">
                    <div class="label">账号：</div>
                    <div class="search_input">
                        <el-input  v-model="searchForm.loginAccount" clearable placeholder="请输入账号"/>
                    </div>
                </div>
                <div class="seache_item">
                    <div class="label">账号：</div>
                    <div class="search_input">
                            <el-select v-model="searchForm.rolePid" placeholder="请选择角色" clearable>
                                <el-option
                                        v-for="item in roleData"
                                        :key="item.pid"
                                        :label="item.roleName"
                                        :value="item.pid">
                                </el-option>
                            </el-select>
                    </div>
                </div>

            </div>
            <div class="seache_right">
                <el-button type="primary" @click="getUserList(1)">查询</el-button>
                <el-button type="primary" @click="dialogVisible = true" style="margin: 0px 0px 0px 10px">新增</el-button>
            </div>
        </div>

        <el-table
                ref="singleTable"
                :data="tableData"
                highlight-current-row
                style="width: 100%;align:center;margin-top: 5px">
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="loginAccount"
                    label="账号">
            </el-table-column>
            <el-table-column
                    prop="realName"
                    label="姓名"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="roleName"
                    label="角色">
            </el-table-column>
            <el-table-column
                    prop="updateDate"
                    label="更新时间">
            </el-table-column>
            <el-table-column
                    label="操作">
                <template slot-scope="scope">
                    <el-button class="btn-text-edit" size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                    <el-button class="btn-text-edit" size="mini" type="primary " @click="updatePword(scope.row.pid)">
                        修改密码
                    </el-button>
                    <el-button class="btn-text-edit" size="mini"
                               type="danger" @click="deleteUser(scope.row.pid)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination_bottom"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="parseInt(searchForm.pageNum)"
                       :total="searchForm.total"
                       :page-size="searchForm.pageSize"
                       :page-sizes="[10, 20, 50,100, 200]"
                       layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>

        <!--新增或编辑-->
        <el-dialog :title=dialogTitle :visible.sync="dialogVisible" :before-close="dialogCancel" width="500px">
            <el-form :model="dialogData" :rules="rules" ref="addRef">
                <el-form-item label="姓名:" :label-width="formLabelWidth" prop="realName">
                    <el-input v-model="dialogData.realName" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="账号:" :label-width="formLabelWidth" prop="loginAccount">
                    <el-input v-model="dialogData.loginAccount" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="角色:" :label-width="formLabelWidth" style="text-align: left;" prop="rolePidList">
                    <el-select v-model="dialogData.rolePidList" multiple placeholder="请选择角色" @change="selectUpdate" style="width: 300px">
                        <el-option
                                v-for="item in roleData"
                                :key="item.pid"
                                :label="item.roleName"
                                :value="item.pid+''">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="dialogTitle == '新增'" label="密码:" :label-width="formLabelWidth"
                              prop="loginPassword">
                    <el-input v-model="dialogData.loginPassword" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item v-if="dialogTitle == '新增'" label="确认密码:" :label-width="formLabelWidth"
                              prop="verifyPassword">
                    <el-input v-model="dialogData.verifyPassword" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="描述:" :label-width="formLabelWidth" >
                    <el-input v-model="dialogData.remarks"
                              style="width: 300px"
                              type="textarea"
                              maxlength="80"
                              show-word-limit
                              autocomplete="off">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm()">确 定</el-button>
            </div>
        </el-dialog>

        <!--修改密码-->
        <el-dialog title="修改密码" :visible.sync="dialogPwdVisible" :before-close="dialogPwdCancel" width="500px">
            <el-form :model="dialogPwdData" :rules="pawordRules" ref="pawordRef">
                <el-form-item label="新密码:" :label-width="formLabelWidth" prop="loginPassword">
                    <el-input v-model="dialogPwdData.loginPassword" autocomplete="off" placeholder="请输入密码" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="确认密码:" :label-width="formLabelWidth" prop="verifyPassword">
                    <el-input v-model="dialogPwdData.verifyPassword" autocomplete="off"
                              placeholder="请输入确认密码" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPwdCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogPwdAffirm()">确 定</el-button>
            </div>
        </el-dialog>

        <!--删除-->
        <el-dialog title="提示" :visible.sync="dialogDeleteVisible" width="500px" :before-close="dialogDeleteCancel">
            <span>确定要删除该用户吗？</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeleteCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogDeleteAffirm()">确 定</el-button>
            </div>
        </el-dialog>

    </div>


</template>

<script>

    export default {
        data() {
            return {
                rules: {
                    realName: [
                        {required: true, message: "请输入姓名", trigger: "blur"}
                    ],
                    loginAccount: [
                        {required: true, message: "请输入账号", trigger: "blur"}
                    ],
                    rolePidList: [
                        {required: true, message: "请选择角色", trigger: "blur"}
                    ],
                    loginPassword: [
                        {required: true, message: "请输入密码", trigger: "blur"}
                    ],
                    verifyPassword: [
                        {required: true, message: "请输入确认密码", trigger: "blur"}
                    ],
                },
                pawordRules: {
                    loginPassword: [
                        {required: true, message: "请输入密码", trigger: "blur"}
                    ],
                    verifyPassword: [
                        {required: true, message: "请输入确认密码", trigger: "blur"}
                    ],
                },
                searchForm: {
                    loginAccount: '',
                    realName: '',
                    rolePid: null,
                    pageNum: 1,
                    pageSize: 10,
                    total: null
                },
                dialogTitle: '新增',
                tableData: [],
                roleData: [],
                dialogData: {
                    pid: null,
                    loginAccount: '',
                    realName: '',
                    roleList: null,
                    rolePidList: [],
                    loginPassword: '',
                    verifyPassword: '',
                    remarks: ''
                },
                dialogPwdData: {
                    pid: '',
                    loginPassword: '',
                    verifyPassword: ''
                },
                dialogVisible: false,
                dialogPwdVisible: false,
                dialogDeleteVisible: false,
                formLabelWidth: '100px',
                deletePid: null
            }
        },
        created() {
            this.getUserList();
            this.getRoleList();
        },
        methods: {
            selectUpdate(val) {
                this.$forceUpdate();
            },
            handleCurrentChange(val) {
                this.searchForm.page = val;
                this.getUserList();
            },
            handleSizeChange(val) {
                this.searchForm.size = val;
                this.getUserList();
            },
            getRoleList() {
                this.$post(this.$url.角色列表, {}).then((res) => {
                    this.roleData = res.list;
                }).catch((err) => {
                    Promise.reject(err);
                });
            },
            getUserList(val) {
                if (val == 1) this.searchForm.page = 1;
                this.$post(this.$url.用户列表, this.searchForm).then((res) => {
                    this.tableData = res.list;
                    this.searchForm.pageNum = parseInt(res.pageNum);
                    this.searchForm.pageSize = parseInt(res.pageSize);
                    this.searchForm.total = parseInt(res.total);
                }).catch((err) => {
                    Promise.reject(err);
                });
            },
            edit(row) {
                this.dialogTitle = "编辑";
                this.dialogVisible = true;
                this.dialogData = row;
                this.dialogData.rolePidList = this.dialogData.rolePid.split(",");
            },
            updatePword(pid) {
                this.dialogPwdVisible = true;
                this.dialogPwdData = {
                    pid: pid,
                    loginPassword: '',
                    verifyPassword: ''
                }
            },
            deleteUser(pid) {
                this.dialogDeleteVisible = true;
                this.deletePid = pid;
            },
            dialogAffirm() {
                this.$refs["addRef"].validate((valid) => {
                    if (valid) {
                        var url = this.$url.用户添加;
                        if (this.dialogTitle == "新增") {
                            url = this.$url.用户添加;
                        } else {
                            url = this.$url.用户修改;
                        }
                        this.dialogData.roleList = this.dialogData.rolePidList.join();
                        this.$post(url, this.dialogData).then((res) => {
                            this.$message.success("成功");
                            this.dialogCancel();
                            this.getUserList(1);
                        }).catch((err) => {
                            //this.dialogVisible = false;
                            Promise.reject(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            dialogCancel() {
                this.$refs["addRef"].resetFields();
                this.dialogVisible = false;
                this.dialogTitle = "新增";
                this.dialogData = {
                    pid: null,
                    loginAccount: '',
                    realName: '',
                    rolePid: null,
                    rolePidList: [],
                    loginPassword: '',
                    verifyPassword: '',
                    remarks: ''
                }
            },
            dialogPwdAffirm() {
                this.$refs["pawordRef"].validate((valid) => {
                    if (valid) {
                        this.$post(this.$url.用户修改密码, this.dialogPwdData).then((res) => {
                            this.$message.success("成功");
                            this.dialogPwdVisible = false;
                        }).catch((err) => {
                            this.dialogPwdVisible = false;
                            Promise.reject(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            dialogPwdCancel() {
                this.$refs["pawordRef"].resetFields();
                this.dialogPwdVisible = false;
                this.dialogPwdData = {
                    pid: null,
                    loginPassword: '',
                    verifyPassword: ''
                }
            },
            dialogDeleteCancel() {
                this.dialogDeleteVisible = false;
                this.deletePid = null;
                this.getUserList(1);
            },
            dialogDeleteAffirm() {
                this.$post(this.$url.用户删除, {pid: this.deletePid}).then((res) => {
                    this.$message('删除成功');
                    this.dialogDeleteVisible = false;
                    this.getUserList(1);
                }).catch((err) => {
                    this.dialogDeleteVisible = false;
                    Promise.reject(err);
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .title_header {
        text-align: left;
        padding: 20px 20px 10px 20px;
        background-color: #FFFFFF;
        margin-bottom: 3px;
    }

    .pagination_bottom {
        text-align: right;
        background-color: #FFFFFF;
        padding: 22px 20px;

    }

    .from_header {
        background-color: #FFFFFF;
        width: 100%;
        height: 60px;
        line-height: 60px;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        align-items: center;


        .seache_left {
            width: 80%;
            height: 100%;
            display: inline-block;
            .seache_item {
                width: 240px;
                display: inline-block;
                margin-right: 20px;
                .label{
                    display: inline-block;
                    width: 30%;
                    text-align: right;
                }
                .search_input{
                    display: inline-block;
                    max-width: 70%;
                }
            }

        }

        .seache_right {
            width: 18%;
            height: 100%;
            display: inline-block;
            text-align: right;
        }

    }
</style>
